const config = {
    baseUrl: "https://raw.githubusercontent.com/doshea/nyt_crosswords/master/"
}
export default config
